import React from "react";
import { NavigationButton, GeoLocationInput } from "@shared";
import DynamicHtml from "@common/DynamicHtml";

const SearchSection = ({
  subHeaderText,
  safeChannelName,
  channel,
  isSearchRequired,
  handleLocationChange,
  initiateCoverageSearch,
  handleLocationClear,
  locationLabel,
  geographyType,
  locationErrorMessage, 
  states, 
  highlightGeoInput, 
  showPostSearch, 
  changeSelectedResultButtonLabel, 
  changeSelectedResultButtonIcon, 
  handleChangeSelectedResult, 
  isSearchEnabled, 
  searchButtonRef,
  hideLocation,
  matchesMobileWidth,
  resultName,
  hierarchyShortName,
  stateName,
  zipCode,
  searchPageState,
}) => {
  const showChangeSelectedResultButton = showPostSearch && (!hideLocation || matchesMobileWidth);

  return (
  <div className={`norstella-pf-row norstella-pf-row-search norstella-pf-${safeChannelName}-row-search norstella-pf-${safeChannelName}-row-${searchPageState}-search`}>
    <div className={`norstella-pf-subheader norstella-pf-${safeChannelName}-subheader norstella-pf-${safeChannelName}-${searchPageState}-subheader`}>
      {subHeaderText && subHeaderText.trim() !== "" && (
        <DynamicHtml
          part="pfDivSubHeaderText"
          input={subHeaderText}
          className={`norstella-pf-nav-subheader norstella-pf-nav-${searchPageState}-subheader`}
          channelName={channel.channelName}
          resultname={resultName}
          hierarchyShortName={hierarchyShortName}
          stateName={stateName}
          zipCode={zipCode} 
        />
      )}
    </div>
    <div className={`norstella-pf-geo norstella-pf-geo-${searchPageState}-search norstella-pf-${safeChannelName}-geo-${searchPageState}-search`}>
      {isSearchRequired && (
        <>
          <GeoLocationInput
            geoLocationProps={{
              geographyType: geographyType,
              onChange: handleLocationChange,
              onEnter: initiateCoverageSearch,
              onClear: handleLocationClear,
              locationLabel,
              errorMessage: locationErrorMessage,
              states,
              highlight: highlightGeoInput,
              partName: "pfLocation",
              classNamePrefix: "norstella-pf",
              identifier: safeChannelName,
              disabled: showPostSearch,
              hideLocation: hideLocation
          }}
          />
          {!showPostSearch && (
            <div className={`norstella-pf-location-input-row norstella-pf-${safeChannelName}-location-input-row`}>
              <button
                type="button"
                className={`norstella-pf-primary-btn norstella-pf-${safeChannelName}-primary-btn`}
                onClick={initiateCoverageSearch}
                disabled={!isSearchEnabled}
                part="pfSearchButton"
                ref={searchButtonRef}
                disableFocusRipple={true}
              >
                Search
              </button>
            </div>
          )}
        </>
      )}
      {showChangeSelectedResultButton && (
        <div className={`norstella-pf-nav-changeSelectedResult norstella-pf-${safeChannelName}-nav-changeSelectedResult`}>
          <NavigationButton
            label={changeSelectedResultButtonLabel}
            icon={changeSelectedResultButtonIcon}
            className={"norstella-pf-changeSelectedResult-btn"}
            onClick={handleChangeSelectedResult}
            identifier={safeChannelName}
          />
        </div>      
      )}
    </div>
  </div>
);
}

export default SearchSection;
